/**
 * Footer component for the application.
 *
 * @module Footer
 * @returns {JSX.Element} The rendered Footer component.
 */
import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { ThemeContext } from './ThemeContext.js'

const Footer = () => {
  const { theme } = useContext(ThemeContext)
  return (
    <>
      <Row className='mt-5 pt-3 pb-2'>
        <Col className='text-center' style={{ color: theme.subtext }}>
          Copyright &copy; Hermanos Gazpachos Inc. 2026. All rights reserved.
        </Col>
      </Row>
    </>
  )
}

export default Footer
